<template>
  <div>
    <!-- <p
      class="fixed z-50 top-20 font-normal bg-root-1 pt-2 md:pt-0 pb-2 pr-2 pl-3 md:pl-0 md:-ml-2 text-sm lg:text-base text-gray-40"
    >
      {{ activeTitle }}
    </p> -->
    <el-tabs class="" v-model="activeTitle" @tab-click="handleClick">
      <el-tab-pane label="Profile" name="Profile"></el-tab-pane>
      <!-- <el-tab-pane label="Security" name="Security"></el-tab-pane> -->
      <el-tab-pane
        v-if="!isTorusUser"
        label="Wallet Address"
        name="Wallet Address"
      ></el-tab-pane>
      <el-tab-pane
        v-if="isUserKindOwner"
        label="User Management"
        name="User Management"
      ></el-tab-pane>
      <el-tab-pane v-if="!isManualKycType" label="Contracts" name="Contracts">
        <el-tooltip
          class="item"
          effect="light"
          :disabled="!isUserKindViewOnly"
          :content="'No access to view contracts'"
          placement="bottom"
        ></el-tooltip>
      </el-tab-pane>
      <el-tab-pane
        v-if="isOnDevEnvironment"
        label="Beneficiaries"
        name="Beneficiaries"
      >
      </el-tab-pane>
      <el-tab-pane
        v-if="hasApiAccess"
        label="API Keys And Webhooks"
        name="API Keys And Webhooks"
      >
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import userKinds from '@/mixins/userKinds.js'
export default {
  name: 'SettingsNavigation',
  mixins: [userKinds],
  data () {
    return {
      route: ''
    }
  },
  props: {
    activeTitle: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick (tab) {
      this.route = tab.label.toLowerCase()
      if (tab.label === 'User Management') {
        this.route = 'user-management'
      } else if (tab.label === 'API Keys And Webhooks') {
        this.route = 'api-keys-and-webhooks'
      } else if (tab.label === 'Wallet Address') {
        this.route = 'wallet-address'
      }
      this.$router.push(`/settings/${this.route}`)
    }
  },
  computed: {
    isOnDevEnvironment () {
      return process.env.NODE_ENV !== 'production'
    },
    isManualKycType () {
      return this.$store.state.auth.business.kycType === 'manual'
    },
    hasApiConfig () {
      return this.$store.state.auth.businessConfig.has_api_config
    },
    hasLimitedSettings () {
      return process.env.VUE_APP_SETTINGS_LIMITED === 'true'
    },
    user () {
      return this.$store.state.auth.user
    },
    compActiveTitle () {
      return this.activeTitle
    },
    isTorusUser () {
      return process.env.VUE_APP_TENANT_NAME === 'torus'
    },
    hasApiAccess () {
      return process.env.VUE_APP_API_ACCESS === 'true' && this.hasApiConfig
    }
  }
}
</script>

<style scoped>
>>> .el-tabs__item.is-active {
  color: var(--color-primary);
}
>>> .el-tabs__active-bar.is-top {
  background: var(--color-primary);
}
>>> .el-tabs.is-top {
  background: green;
}
>>> .el-tabs__item:hover {
  color: var(--color-primary);
}
>>> .el-tabs__item {
  color: var(--text-1);
}
>>> .el-tabs__nav-wrap::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0%;
  height: 2px;
  background-color: #e4e7ed;
  z-index: 1;
}
</style>
